/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dd_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes — switch to Countdown mode and enter a single target date. The calculator shows how many days remain until that date, or how many days have passed if it's already in the past, using today's date as the starting point.`)
};

const es_dd_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí — cambia al modo Cuenta atrás e introduce una fecha objetivo única. La calculadora muestra cuántos días faltan hasta esa fecha, o cuántos días han pasado si ya es en el pasado, usando la fecha de hoy como punto de partida.`)
};

const de_dd_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja — schalten Sie in den Countdown-Modus und geben Sie ein einzelnes Zieldatum ein. Der Rechner zeigt, wie viele Tage bis zu diesem Datum verbleiben, oder wie viele Tage vergangen sind, falls es bereits in der Vergangenheit liegt, wobei heute als Ausgangspunkt verwendet wird.`)
};

const nl_dd_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja — schakel over naar Aftellingsmodus en voer een enkele doeldatum in. De calculator toont hoeveel dagen nog restaan tot die datum, of hoeveel dagen voorbij zijn als deze al in het verleden ligt, met vandaag als startpunt.`)
};

const fr_dd_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui — passez en mode Compte à rebours et entrez une seule date cible. La calculatrice affiche combien de jours restent jusqu'à cette date, ou combien de jours se sont écoulés si elle est déjà dans le passé, en utilisant la date d'aujourd'hui comme point de départ.`)
};

const it_dd_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì — passa alla modalità Conto alla rovescia e inserisci una data obiettivo singola. Il calcolatore mostra quanti giorni rimangono fino a quella data, o quanti giorni sono passati se è già nel passato, usando la data di oggi come punto di partenza.`)
};

const pt_br2_dd_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim — alterne para o modo Contagem Regressiva e digite uma única data alvo. A calculadora mostra quantos dias faltam até essa data, ou quantos dias se passaram se já estiver no passado, usando a data de hoje como ponto de partida.`)
};

const pt_dd_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim — mude para o modo de Contagem Regressiva e introduza uma única data de destino. A calculadora mostra quantos dias faltam até essa data, ou quantos dias passaram se já tiver passado, utilizando a data de hoje como ponto de partida.`)
};

const ja_dd_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい — カウントダウンモードに切り替えて、単一の対象日を入力してください。計算機は、その日付までの残り日数、または日付が既に過去の場合は本日の開始点を使用して経過した日数を表示します。`)
};

const zh_dd_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以——切换到倒计时模式，输入一个目标日期即可。计算器会以今天的日期为起点，显示距离该日期还有多少天，如果该日期已经过去，则显示已经过去了多少天。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dd_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dd_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dd_faq4_a", locale)
	if (locale === "en") return en_dd_faq4_a(inputs)
	if (locale === "es") return es_dd_faq4_a(inputs)
	if (locale === "de") return de_dd_faq4_a(inputs)
	if (locale === "nl") return nl_dd_faq4_a(inputs)
	if (locale === "fr") return fr_dd_faq4_a(inputs)
	if (locale === "it") return it_dd_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_dd_faq4_a(inputs)
	if (locale === "pt") return pt_dd_faq4_a(inputs)
	if (locale === "ja") return ja_dd_faq4_a(inputs)
	return zh_dd_faq4_a(inputs)
};